{
  "markread": "Označit jako přečtené",
  "filter": "Zobrazovat",
  "newest": "Nejnovější",
  "unread": "Nepřečtené",
  "starred": "Označené",
  "tags": "Štítky",
  "alltags": "Všechny štítky",
  "timestamp": "{0,date} {0,time}",
  "hours": "před {0,plural,one {1 hodinou},other {# hodinami}}",
  "minutes": "před {0,plural,one {1 minutou},other {# minutami}}",
  "seconds": "před {0,plural,one {chvílí},other {# sekundami}}",
  "days": "{0,plural,zero {dnes},one {včera},other {před # dny}}",
  "star": "Označit",
  "unstar": "Odznačit",
  "mark": "Označit jako přečtené",
  "unmark": "Označit jako nepřečtené",
  "load_img": "Zobrazit obrázky",
  "open_window": "Otevřít",
  "next": "Další",
  "search_label": "Vyhledávaný text",
  "searchbutton": "Hledat",
  "searchremove": "Skrýt hledání",
  "refreshbutton": "Obnovit zdroje",
  "settingsbutton": "Nastavení",
  "logoutbutton": "Odhlásit se",
  "loginbutton": "Přihlásit se",
  "sources": "Zdroje",
  "sources_loading": "Načítání zdrojů…",
  "no_sources": "Nejsou nastaveny žádné zdroje.",
  "source_add": "Přidat zdroj",
  "source_opml": "nebo nahrát opml soubor",
  "source_export": "Export zdrojů",
  "source_edit": "Upravit",
  "source_filter": "Filtr",
  "source_menu": "Více akcí",
  "source_browse": "Prohlížet",
  "source_delete": "Smazat",
  "source_warn": "Opravdu chcete tento zdroj smazat?",
  "source_deleting": "Mazání zdroje…",
  "source_warn_cancel_dirty": "Opravdu chcete zahodit neuložené změny?",
  "source_new": "Nový neuložený zdroj",
  "source_title": "Název",
  "source_autotitle_hint": "Pro automatické vyplnění ponechte prázdné",
  "source_tags": "Štítky",
  "source_pwd_placeholder": "Beze změny",
  "source_comma": "Oddělené čárkou",
  "source_select": "Vyberte prosím zdroj",
  "source_params_loading": "Načítání parametrů…",
  "source_type": "Typ",
  "source_save": "Uložit",
  "source_cancel": "Zrušit",
  "source_saving": "Ukládání změn zdroje…",
  "source_saved": "Uloženo",
  "source_last_post": "Poslední příspěvek spatřen",
  "source_refresh": "Obnovit tento zdroj",
  "source_go_to_settings": "Otevřít v nastavení",
  "sources_leaving_unsaved_prompt": "Na stránce jsou neuložené změny. Opravdu chcete opustit nastavení?",
  "tag_change_color_button_title": "Změnit barvu",
  "entries_loading": "Načítání záznamů…",
  "no_entries": "Žádný záznam",
  "more": "Více",
  "login": "Přihlásit",
  "login_in_progress": "Přihlašování…",
  "login_username": "Jméno",
  "login_password": "Heslo",
  "login_invalid_credentials": "Špatné jméno nebo heslo",
  "login_error_generic": "Pokus o přihlášení selhal: {errorMessage}",
  "no_title": "Bez titulku",
  "error": "Nastala chyba",
  "error_unauthorized": "Pro pokračování se prosím {link_begin}přihlaste{link_end}.",
  "error_check_log_file": "Nastala chyba, zkontrolujte prosím záznamy v souboru „{0}“.",
  "error_check_system_logs": "Nastala chyba, zkontrolujte prosím záznamy v operačním systému.",
  "error_unwritable_logs": "Nebylo možné zaznamenat chybu.",
  "streamerror": "Nenačteny žádné položky, zkusit znovu?",
  "reload_list": "Znovu načíst seznam",
  "sources_refreshed": "Zdroje byly obnoveny",
  "error_session_expired": "Vaše sezení vypršelo",
  "error_add_source": "Zdroj nemohl být přidán:",
  "error_delete_source": "Zdroj nemohl být smazán:",
  "error_load_tags": "Štítky nemohly být načteny:",
  "error_unknown_tag": "Neznámý štítek:",
  "error_unknown_source": "Neznámé id zdroje:",
  "error_mark_items": "Nelze označit všechny viditelné zdroje:",
  "error_mark_item": "Nelze označit položku za (ne)přečtenou:",
  "error_star_item": "Nelze o(d)značit položku hvězdičkou:",
  "error_logout": "Odhlášení se nezdařilo:",
  "error_loading": "Chyba načítání:",
  "error_loading_stats": "Načítání statistik se nezdařilo:",
  "error_saving_color": "Nelze změnit barvu:",
  "error_refreshing_source": "Nelze obnovit zdroje:",
  "error_sync": "Synchronizace změn ze serveru selhala:",
  "error_invalid_subsection": "Podsekce neexistuje:",
  "online_count": "Položky dostupné na serveru",
  "offline_count": "Položky jsou dostupné v prohlížeči",
  "offline_navigation_unavailable": "Offline režim zatím neumožňuje přepínat mezi štítky a zdroji.",
  "login_offline": "Ukládat data v prohlížeči",
  "app_update": "selfoss byl aktualizován, prosím znovu načtěte stránku",
  "app_reload": "Znovu načíst",
  "error_offline_storage": "Chyba lokálního úložiště: {0}. Možná pomůže znovunačtení stránky. Prozatím bude ukládání vypnuto.",
  "article_actions": "Akce",
  "error_configuration": "Nelze načíst konfiguraci.",
  "share_native_label": "Sdílet",
  "share_diaspora_label": "Sdílet na Diaspoře",
  "share_twitter_label": "Sdílet na Twitteru",
  "share_facebook_label": "Sdílet na Facebooku",
  "share_pocket_label": "Uložit do Pocketu",
  "share_wallabag_label": "Uložit do Wallabagu",
  "share_wordpress_label": "Sdílet na WordPressu",
  "share_mail_label": "Sdílet e-mailem",
  "share_copy_label": "Zkopírovat odkaz do schránky",
  "info_url_copied": "URL zkopírována do schránky.",
  "error_share_native_abort": "Nelze sdílet položku: buď váš prohlížeč nepodporuje sdílení odkazů, nebo jste sdílení zrušili.",
  "error_share_native": "Nelze sdílet položku.",
  "close_entry": "Zavřít",
  "article_reading_time": "{0} min čtení",
  "error_offline_storage_not_available": "Offline úložiště není dostupné. Ujistěte se, že váš prohlížeč {0}podporuje rozhraní IndexedDB{1} a, pokud používáte prohlížeč založený na Google Chrome, že nespouštíte selfoss v režimu anonymního prohlížení.",
  "error_edit_source": "Nelze uložit změny zdroje:",
  "experimental": "Experiment"
}
